module.exports = __webpack_public_path__ + "static/media/awards.592eb09c.png";